import { useParams } from 'react-router-dom';
import ActivateForm from './components/ActivateForm';

import { useTheme } from '@/helpers/theme';
import { useUserByActivationId } from '@/data/user';
import Loader from '@/components/common/Loader';

const Page = () => {
  useTheme();
  const { activationId } = useParams();
  const user = useUserByActivationId(activationId);

  if (user.isLoading && !user.data) {
    return (
      <div className="flex items-center justify-center p-4 h-screen w-screen bg-topography bg-login-bg bg-blend-overlay">
        <Loader />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-4 h-screen w-screen bg-topography bg-login-bg bg-blend-overlay">
      <ActivateForm user={user.data} />
    </div>
  );
};

export default Page;
